import request from '@/utils/requset'
 
// 实验列表
export function expList(data) {
  return request({
    url: `h5/course/lists`,
    method: 'post',
    data: data
  })
} 

// 实验分类
export function expCategory() {
  return request({
    url: `h5/course/category`,
    method: 'post'
  })
} 